import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const AbsolutesBlackColors = createInteractiveColorVars('absolute-black');
const AbsolutesBlackColorsLightValues = Object.freeze({
    base: {
        default: '#000000',
        action: '#313131',
        active: '#000000',
        activeAction: '#313131',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const AbsolutesBlackColorsDarkValues = Object.freeze({
    base: {
        default: '#000000',
        action: '#313131',
        active: '#000000',
        activeAction: '#313131',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { AbsolutesBlackColors, AbsolutesBlackColorsDarkValues, AbsolutesBlackColorsLightValues };
